import React, { Component } from "react";
import {Row,Col,Button,Modal,Container} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "react-switch";

class AddCountryCrncy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        countryId: "Select Country",
        currencyId: "Select Currency",
        isActive: true,
      },
    };
  }

  submit = () => {
    const value = this.state.value;

    if (
      value.countryId !== "Select Country" &&
      value.currencyId !== "Select Currency"
    ) {
      this.props.AddCntryCrncy(this.state.value);
      this.setState({
        value: {
          ...this.state.value,
          countryId: "Select Country",
          currencyId: "Select Currency",
          isActive: true,
        },
      });

      this.props.closeAddModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  handleChange = (checked) => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };

  selectCountry = (event) => {
    this.setState({
      value: { ...this.state.value, countryId: event.target.value },
    });
  };

  selectCurrency = (event) => {
    this.setState({
      value: { ...this.state.value, currencyId: event.target.value },
    });
  };

  closeModel = () => {
    this.setState({
      value: {
        ...this.state.value,
        countryId: "Select Country",
        currencyId: "Select Currency",
        isActive: true,
      },
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <div>
          <Modal
            show={this.props.showAddModel}
            onHide={this.closeModel}
            animation={false}
            size="md"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Country Currency</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Row>
                  <Col lg={12}>
                    <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Form.Group
                          style={{
                            marginBottom: 15,
                            width: "100%",
                            height: 35,
                          }}
                        >
                          <Form.Control
                            as="select"
                            onChange={this.selectCountry}
                          >
                            <option>Select Country</option>
                            {this.props.CountrysList &&
                              this.props.CountrysList.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group
                          style={{
                            marginBottom: 15,
                            width: "100%",
                            height: 35,
                          }}
                        >
                          <Form.Control
                            as="select"
                            onChange={this.selectCurrency}
                          >
                            <option>Select Currency</option>
                            {this.props.CurrencyList &&
                              this.props.CurrencyList.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>

                        <div style={{ display: "flex" }}>
                          <label style={{ display: "flex", marginTop: "8px" }}>
                            <div style={{ marginRight: "30px" }}>
                              <span>Active</span>
                            </div>
                            <div style={{ marginTop: "-5px" }}>
                              <Switch
                                onChange={this.handleChange}
                                onColor="#20a8d8"
                                checked={this.state.value.isActive}
                              />
                            </div>
                          </label>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </Modal.Body>

            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
              <Button className="CategorybtnSubmit" onClick={this.submit}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default AddCountryCrncy;
